<template>
    <div>
        <div class="scroll-list">
            <div class="triggers-list" id="NotesZone">
                <div class="list-item heightAuto listing-height1">
                    <button type="button" @click="add()" class="md-button md-theme-default">
                        <div class="md-ripple">
                            <span class="md-button-content">
                                <div class="line-item title-line">
                                    <div class="right-item">
                                        <i class="icon icon-add action"></i>Add Note
                                    </div>
                                </div>
                            </span>
                        </div>
                    </button>
                </div>
                <div id="add-Note">
                    <div v-for="(note, index) in noteList" :key="index" class="md-button-content">
                        <div class="line-item title-line paddingClass">
                            <div class="left-item widthClass">
                                <textarea class="textAreaClass" id="notes_description" v-if="!editTableIndex.includes(index) && saveFlag" v-model="note.Description" placeholder="Type note here ...."></textarea>
                                <p v-else-if="!notesIndexList.includes(index)">
                                    <span class="note_description">{{ note.Description.substring(0, 60) }}
                                        <span v-if="note.Description.length>=60">...</span>
                                    </span>
                                    <span v-if="note.Description.length>=60" @click="showComplete(note,index)">
                                        <b class="show_less"><a href="#">Show more</a></b>
                                    </span>
                                    <span class="notesdate">{{ note.date }}</span>
                                </p>
                                <p v-else-if="notesIndexList.includes(index)">
                                    <span class="note_description">{{ note.Description.substring(0, 1100) }}</span>
                                    <span v-if="note.Description.length>=60" @click="showComplete(note,index)">
                                        <b class="show_less"><a href="#">Show less</a></b>
                                    </span>
                                    <span class="notesdate">{{ note.date }}</span>
                                </p>
                            </div>
                            <div class="right-item rightWidth">
                                <i v-if="editTableIndex.includes(index)" @click="edit(index, note.id)" class="md-icon md-icon-font md-theme-default action">mode_edit</i>
                                <br>
                                <i v-if="editTableIndex.includes(index)" @click="confirmRemove(note, index)" class="md-icon md-icon-font md-theme-default action">delete</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="SaveNotes">
                <div class="btnClass" v-if="saveFlag">
                    <button class="md-button md-primary md-raised btn-danger md-theme-default" @click="refreshScreen()">
                        <div class="md-ripple">
                            <span class="md-button-content">Cancel</span>
                        </div>
                    </button>
                    <button type="submit" class="md-button md-primary md-raised md-theme-default" @click="saveNotes()">
                        <div class="md-ripple">
                            <span class="md-button-content">Save</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog" id="NotesZoneModel">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Do you want to delete this note?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="remove(note, index)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {triggerNotesByZone, saveNotestrigger, deleteNotestrigger} from '../../services/TriggerService.js';

export default {
  data: () => ({
    popArray: [],
    notesIndexList: [],
    showDeleteDialog: false,
    saveFlag: false,
    returnPath: '',
    noteList: [{
      id: '',
      Description: '',
      editFlag: false
    }],
    editBoxId: [],
    editTableIndex: [],
    responseError: false
  }),
  computed: {
    ...mapGetters('user', ['notesSave', 'currentUser']),
    ...mapGetters('triggers', ['currentTrigger'])
  },
  methods: {
    ...mapActions('user', ['clearUserToEdit']),
    async refreshScreen () {
      this.notesIndexList = [];
      this.saveFlag = false;
      let result = await triggerNotesByZone(this.currentTrigger['id']);
      this.noteList = result.data;
      this.returnPath = this.$store.state.RouterModule.from.fullPath;
      for (let index = 0; index < this.noteList.length; index++) {
        this.noteList[index]['editFlag'] = true;
        this.editTableIndex.push(index);
      }
    },
    async saveNotes () {
      try {
        await saveNotestrigger(this.noteList, this.currentTrigger['id'], this.currentTrigger['toiId']);
      } catch (err) {
        console.error('Could not save notes.', err);
      }
      this.saveFlag = false;
      let result = await triggerNotesByZone(this.currentTrigger['id']);
      this.noteList = result.data;
      this.returnPath = this.$store.state.RouterModule.from.fullPath;
      for (let index = 0; index < this.noteList.length; index++) {
        this.noteList[index]['editFlag'] = true;
        this.editTableIndex.push(index);
      }
    },
    add () {
      this.saveFlag = true;
      this.noteList.push({
        id: '',
        Description: '',
        editFlag: true
      });
      this.notesIndexList = [];
    },
    edit (index, id) {
      this.saveFlag = true;
      this.editBoxId.push(id);
      this.editTableIndex = this.editTableIndex.filter(function (item) {
        return item !== index;
      });
      this.notesIndexList = [];
    },
    confirmRemove (note, index) {
      this.showDeleteDialog = true;
      this.note = note;
      this.index = index;
      this.notesIndexList = [];
    },
    showComplete (note, index) {
      if (!this.notesIndexList.includes(index)) {
        this.notesIndexList.push(index);
      } else {
        this.notesIndexList.pop(index);
      }
    },
    async remove (note, index) {
      this.editBoxId = this.editBoxId.filter(function (item) {
        return item !== index;
      });
      this.editTableIndex = this.editTableIndex.filter(function (item) {
        return item !== index;
      });
      this.editTableIndex = [];
      await deleteNotestrigger(note.id);
      let result = await triggerNotesByZone(this.currentTrigger['id']);
      this.noteList = result.data;
      for (let index1 = 0; index1 < this.noteList.length; index1++) {
        this.noteList[index1]['editFlag'] = true;
        this.editTableIndex.push(index1);
      }
      this.showDeleteDialog = false;
      this.notesIndexList = [];
    }
  },
  async mounted () {
    let result = await triggerNotesByZone(this.currentTrigger['id']);
    this.noteList = result.data;
    this.returnPath = this.$store.state.RouterModule.from.fullPath;
    for (let index = 0; index < this.noteList.length; index++) {
      this.noteList[index]['editFlag'] = true;
      this.editTableIndex.push(index);
    }
  }
};
</script>
<style lang="scss">
#NotesZone .md-button.md-theme-default.md-primary {
    background-color: #00A8CA !important;
    color: var(--md-theme-default-primary-on-background, #00A8CA);
}

#NotesZone .textAreaClass {
    width: 230px;
    padding-left: 10px;
    padding-right: 10px;
    height: 120px;
}

#NotesZone .edit {
    width: 230px;
    padding-left: 20px;
    padding-right: 10px;
    height: 50px;
}

#NotesZone .btnClass {
    padding-right: 10px;
    float: right;
}

#SaveNotes .btnClass {
    padding-right: 10px;
    float: right;
}

div#NotesZone {
    float: left;
    width: 100%;
    height: 318px;
    overflow-y: auto;
}

#NotesZone .line-item .left-item {
    float: left;
    margin: 18px 0;
}

#NotesZone .action {
    cursor: pointer;
}

span.note_description {
    float: left;
    width: 100%;
}

#NotesZone p {
    float: left;
    width: 100%;
}

b.show_less {
    font-size: 12px;
    cursor: pointer;
}

span.notesdate {
    float: left;
    width: 100%;
    font-size: 12px;
    font-weight: bold;
    color: #666;
}

#NotesZoneModel .classDanger {
    background-color: #d9534f !important;
}

#NotesZoneModel .cancelClass {
    background-color: #00A8CA;
}

#NotesZone .widthClass {
    width: 85%;
}

#NotesZone .paddingClass {
    padding-left: 18px;
}

#NotesZone .rightWidth {
    width: 15%;
}

#NotesZone .heightAuto {
    height: auto;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}

.triggers-list .list-item.listing-height1 {
    height: auto !important;
    min-height: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/tour/TriggerNotesAddTab.vue